/**
 * Die letzte Suche auf /projekte (#18).
 *
 * Marlene am 20.10.2026: „Letzte Suche soll offen bleiben, wenn man die Seite
 * verlässt". Der Begriff stand nur in der Adresse (`?q=`) — der Link „Suche" in
 * der Seitenleiste führt aber auf `/projekte` ohne ihn, und weg war er.
 *
 * 🔑 `sessionStorage`, nicht `localStorage`: Suchbegriffe sind oft Kundennamen.
 * Gemerkt wird für diesen Tab, mit ihm endet es — am geteilten Büro-PC steht
 * morgen nicht mehr da, wen jemand gestern gesucht hat.
 *
 * Jeder Zugriff in try/catch: im privaten Fenster oder bei gesperrtem Speicher
 * wirft schon das Lesen. Dann gibt es eben nichts Gemerktes.
 */

const SCHLUESSEL = "suche_letzte"

export type Auswahl = { contact_id?: number; project_id?: number; phone?: string }

export type LetzteSuche = { q: string; auswahl: Auswahl | null }

export function letzteSucheLesen(): LetzteSuche | null {
  try {
    const roh = sessionStorage.getItem(SCHLUESSEL)
    if (!roh) return null
    const d = JSON.parse(roh) as Partial<LetzteSuche>
    if (typeof d?.q !== "string") return null
    return { q: d.q, auswahl: d.auswahl ?? null }
  } catch {
    return null
  }
}

export function letzteSucheMerken(s: LetzteSuche): void {
  try {
    if (!s.q.trim() && !s.auswahl) sessionStorage.removeItem(SCHLUESSEL)
    else sessionStorage.setItem(SCHLUESSEL, JSON.stringify(s))
  } catch {
    /* privates Fenster / gesperrter Speicher */
  }
}
